import { COUNTRIES } from "@wayflyer/flyui";

import type { PhoneNumber } from "../api-types/jurisdictions/us_schemas";

export const formatSelectedOptionForDisplay = (options, selectedOption) => {
  return options?.find((option) => option.id === selectedOption)?.text;
};

export const formatPhoneNumberForDisplay = (phoneNumber?: PhoneNumber) => {
  if (phoneNumber) {
    const prefix = COUNTRIES.find((country) => country.code === phoneNumber.regionCode)?.prefix;
    return `${prefix} ${phoneNumber.number}`;
  } else {
    return null;
  }
};

// US numbers render grouped 3-3-4 ("123 456 7890"); other regions / non-10-digit are left as-is.
export const formatUsNationalNumber = (number: string): string => {
  const digits = number.replace(/\D/g, "");
  return digits.length === 10 ? digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3") : number;
};
